import { onCommonDeployError, setDeploymentRequestLoading } from "../../../basic/_fetch/_fetchHelpers";
import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { store } from "../../../../../redux/store";
import { DEFAULTS_BUILDER } from "../../../../../redux/reducers/DeploymentReducer";
import { API_BUILDER_PROJECT_NODE } from "../../../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";

export function projectSave({
                                onSuccess,
                                onError,
                                deploymentID,
                                compose,
                            }) {

    const {bodyBuilder} = store.getState().deployment;
    const body = {
        ...{
            custom: typeof deploymentID === 'number' ? bodyBuilder : DEFAULTS_BUILDER,
            ssl: 'letsencrypt',
        }
    };

    // let url = `${URL_BUILDER_PROJECT_SAVE}${deploymentID ? '/' + deploymentID : ''}`;
    let url = `${API_BUILDER_PROJECT_NODE}`;

    if (typeof deploymentID === 'number') url += `?project=${deploymentID}`;
    if (typeof deploymentID === 'number' && !!compose) url += `&compose=true`;

    setDeploymentRequestLoading(true);

    createFetch({
        URL: url,
        method: typeof deploymentID === 'number' ? 'PUT' : 'POST',
        headers: {
            'Authorization': "Bearer " + getCookie(USER_ACCESS_TOKEN_NAME),
            'Content-Type': 'application/json',
        },
        body,
        onSuccess: response => {
            setDeploymentRequestLoading(false);
            if (onSuccess) onSuccess(response);
        },
        onError: response => {
            setDeploymentRequestLoading(false);
            if (onError) onError(response);
            onCommonDeployError(response);
        },
    });
}